import React from "react";

export const CheckIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.55148 12.9485L2.66768 9.3952L1 10.921L6.55148 16L18 5.52576L16.3323 4L6.55148 12.9485Z"
        fill="currentColor"
      />
    </svg>
  );
};
